/** Build driver location update payload; include heading when the browser provides it. */
export function buildLocationUpdatePayload(latitude, longitude, heading) {
  const payload = { latitude, longitude };
  if (
    heading != null
    && !Number.isNaN(heading)
    && heading >= 0
    && heading <= 360
  ) {
    payload.heading = heading;
  }
  return payload;
}

/** Normalize geolocation coords into lat/lng/accuracy/heading fields. */
export function coordsToLocation(coords) {
  const location = {
    latitude: coords.latitude,
    longitude: coords.longitude,
    accuracy: coords.accuracy,
  };
  if (
    coords.heading != null
    && !Number.isNaN(coords.heading)
    && coords.heading >= 0
    && coords.heading <= 360
  ) {
    location.heading = coords.heading;
  }
  return location;
}

/** True when vehicle map marker data changed enough to re-render. */
export function vehicleMarkerDataChanged(prevVehicle, nextVehicle) {
  if (!prevVehicle && !nextVehicle) return false;
  if (!prevVehicle || !nextVehicle) return true;
  const prevHeading = prevVehicle.heading != null ? Number(prevVehicle.heading) : null;
  const nextHeading = nextVehicle.heading != null ? Number(nextVehicle.heading) : null;
  return (
    prevVehicle.id !== nextVehicle.id
    || prevVehicle.status !== nextVehicle.status
    || prevHeading !== nextHeading
  );
}
